import { IconButton } from "@mui/material";
import { Stack } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import TuneIcon from "@mui/icons-material/Tune";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../assets/styles/tokens";
import { useState } from "react";

const options = [
  "01/11/2025 - 01/12/2025",
  "01/11/2025 - 01/12/2025",
  "01/11/2025 - 01/12/2025",
  "01/11/2025 - 01/12/2025",
];

const ClickandImpressionFilter = () => {
  const [value, setValue] = useState<string | null>(options[2]);

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt="13.5px"
        mb={2}
      >
        <Autocomplete
          options={options}
          value={value}
          onChange={(_, newValue) => setValue(newValue)}
          sx={{
            width: "70%",
            "& .MuiInputBase-input": {
              fontSize: typography.Size.Text.sm.$value,
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: spacing.Radius.md.$value,
              "&.Mui-focused fieldset": {
                borderColor: colors.GrayLightMode[300].$value,
                borderWidth: "1px",
              },
              fontWeight: typography.Font_weight.Semibold.$value,
            },
          }}
          size="small"
          renderOption={(props, option, { selected }) => (
            <li
              {...props}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: spacing.Spacing["5xl"].$value,
                position: "relative",
                backgroundColor: selected ? colors.Brand[50].$value : "",
              }}
            >
              {selected && (
                <CheckIcon
                  fontSize="small"
                  sx={{
                    position: "absolute",
                    left: spacing.Spacing.lg.$value,
                  }}
                />
              )}
              <span style={{}}>{option}</span>
            </li>
          )}
          renderInput={(params) => <TextField color="secondary" {...params} />}
        />

        <IconButton color="secondary" size="large">
          <TuneIcon
            fontSize="small"
            sx={{ color: colors.GrayLightMode[700].$value }}
          />
        </IconButton>
      </Stack>
    </>
  );
};

export default ClickandImpressionFilter;
